<!-- Copyright (c) 2009-2022. Authors: see NOTICE file.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.-->

<template>
<cytomine-modal-card :title="$t('about-cytomine')" @close="$parent.close()">
  <template>
    <div class="cytomine-logo">
      <a href="https://cytomine.com" target="_blank">
        <img src="@/assets/sponsors/logo-cytomine-coop.png" class="sponsor">
      </a>
    </div>
    <dl>
      <dt>{{$t('version')}}</dt>
      <dd>{{version || '?'}}</dd>

      <dt>{{$t('description')}}</dt>
      <dd>
        <i18n :path="`cytomine-sponsors-info${editionLabelSuffix}`">
          <a place="cytomineCompanyLink" href="https://cytomine.com" target="_blank">
            {{$t('cytomine-company')}}</a>
        </i18n>
      </dd>

      <dt>{{$t('website')}}</dt>
      <dd>
        <i18n path="cytomine-website-info-ee">
          <a place="websiteLink" href="https://cytomine.com" target="_blank">cytomine.com</a>
        </i18n>
      </dd>

      <dt>{{$t('documentation')}}</dt>
      <dd>
        <i18n path="documentation-info">
          <a place="docLink" href="https://doc.cytomine.com/" target="_blank">{{$t('here')}}</a>
        </i18n>
      </dd>

      <dt>{{$t('disclaimer')}}</dt>
      <dd>{{$t(`cytomine-disclaimer${editionLabelSuffix}`)}}</dd>

      <dt>{{$t('ownership')}}</dt>
      <dd>{{$t(`cytomine-ownership${editionLabelSuffix}`)}}</dd>

      <dt>{{$t('contact')}}</dt>
      <dd>
        <i18n path="contact-info-ee">
          <a place="contactMail" href="mailto:info@cytomine.com">info@cytomine.com</a>
          <a place="supportMail" href="mailto:support@cytomine.com">support@cytomine.com</a>
        </i18n>
      </dd>
    </dl>
  </template>
</cytomine-modal-card>
</template>

<script>
import constants from '@/utils/constants.js';
import CytomineModalCard from '@/components/utils/CytomineModalCard';

export default {
  name: 'about-cytomine-wrapper',
  components: {CytomineModalCard},
  data() {
    return {
      version: constants.CYTOMINE_COMMERCIAL_VERSION
    };
  },
  computed: {
    editionLabelSuffix() {
      return `-${this.version.substr(0, 3).toLowerCase()}`;
    }
  }
};
</script>

<style scoped>
.modal-card, .modal-card-body {
  width: 50vw;
  min-width: 700px;
  font-weight: normal;
}

dt {
  float: left;
  width: 12rem;
  text-align: right;
  padding-right: 1rem;
  clear: both;
  font-weight: 600;
}

dd {
  margin-left: 14rem;
  background-color: #fff;
  margin-bottom: 0.75rem;
}

img.sponsor {
  max-height: 7rem;
  margin-right: 1rem;
}

.cytomine-logo {
  display: flex;
  justify-content: center;
}
</style>
